<ng-container *ngIf="notesList?.length>0; else noNotesAvailable">
    <div *ngFor="let singleNote of notesList">
        <p *ngIf="!truncatedNotes" class=""> {{singleNote?.note}} </p>
        <p *ngIf="truncatedNotes" [matTooltip]="singleNote?.note">{{singleNote?.note?.length > 30 ? (singleNote?.note | slice:0:30):singleNote?.note }}</p>
        <div class="d-flex justify-content-start align-items-start">
            <span class="text-muted text-smaller mb-0 p-0"> {{singleNote.modified | date: "MMM-dd-YYYY"}} </span>
        </div>
    </div> 
</ng-container>

<ng-template #noNotesAvailable>
    <p>No Notes Available</p>
</ng-template>
